import React from 'react';

import type { SharedValue } from 'react-native-reanimated';
import type { ListRef } from '@banhala/ui-kit';
import type { GoodsDetailContentKeys } from '../types/GoodsDetailContentKeys';
import type { GoodsDetailTab } from '../types/GoodsDetailTab';

export const ScrollContext = React.createContext<{
  scrollY?: SharedValue<number>;
  /** 부모 세로 스크롤 진행 여부. true→false 전이가 "스크롤 정지" 시점. */
  isScrolling?: SharedValue<boolean>;
  tabScrollX?: SharedValue<number>;
  listRef?: React.RefObject<ListRef<GoodsDetailContentKeys> | null>;
  scrollToStickyView?: () => void;
  changeContentTab?: (tab: GoodsDetailTab) => void;
  onChangeTab?: (tab: GoodsDetailTab) => void;
}>({});
